/**
 * Created by Kshama on 26/5/16.
 */

angular.module('qkr').controller('BrowserAlertController', ($scope, $uibModalInstance, $uibModal, userManagementService, messageService, appConfig) => {
    $scope.checkboxModel = {
        selected: false
    };

    $scope.errors = {};

    $scope.ok = function() {
        if ($scope.checkboxModel.selected) {
            $scope.saving = true;
            const commandBrowser = {};
            commandBrowser.username = appConfig.username;
            commandBrowser.displayBrowserAlert = !$scope.checkboxModel.selected;
            userManagementService.updateDisplayBrowserAlert(commandBrowser).then((response) => {
                $uibModalInstance.close(true);
            }, (reason) => {
                messageService.error('Error to update browser flag', reason);
                const modalInstance2 = $uibModal.open({
                    template: require('../../templates/common/modalPopup.html'),
                    controller: 'CommonModalPopupController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {
                        title() {
                            return 'Unable to Update Display Browser Alert Check';
                        },
                        message() {
                            return reason.data.exception;
                        }
                    }
                });
            }).finally(
                () => {
                    $scope.saving = false;
                }
            );
        } else {
            $uibModalInstance.close(true);
        }
    };

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };
});



// WEBPACK FOOTER //
// ./src/controllers/modal/browserAlert.controller.js